import React, { useState, useEffect } from 'react';
import './SliderMessenger.css';

const SliderMessenger = () => {
  const messages = [
    "Você sonha, a gente realiza!",
    "Design com essência, exclusividade e personalidade",
    "Móveis Planejados - Projetos Integrados - Design de Interiores",
    "Você sonha, a gente realiza!",
    "Aceitamos todos os cartões de crédito",
    "Design com essência, exclusividade e personalidade!",
    "Você sonha, a gente realiza!",
    "Modelagem de projetos computadorizada",
    "Móveis Planejados - Projetos Integrados - Design de Interiores",
    "Aceitamos todos os cartões de crédito",
    "Design com essência, exclusividade e personalidade",
    "Produção automatizada e com alto grau de precisão"
  ];

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 6000); // Duração total da animação (entrada + permanência + saída)

    return () => clearInterval(interval); // Limpa o intervalo quando o componente é desmontado
  }, [messages.length]); // A dependência aqui garante que o intervalo só seja refeito se o número de mensagens mudar

  return (
    <header className="slider-messenger">
      
      <div className="message-scroller">
        {/* A chave (key) é crucial aqui para forçar o React a re-renderizar o span
            e, assim, reiniciar a animação CSS para a nova mensagem. */}
        <span key={currentMessageIndex} className="message-text animated">
          {messages[currentMessageIndex]}
        </span>
      </div>
      
    </header>
  );
};

export default SliderMessenger;